import React from 'react';
import { Modal } from 'antd';
import IconFont from '../IconFont';
var Prompt = function (props) {
    return Modal.confirm({
        zIndex: 1050,
        width: '433px',
        style: {
            height: '192px',
            padding: 0,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: 'auto',
        },
        title: props.title,
        icon: props.icon || (React.createElement("span", { className: "anticon" },
            React.createElement(IconFont, { type: "iconic_failure", style: { color: '#F96137' } }))),
        onOk: props.onOk,
        onCancel: props.onCancel,
        content: (React.createElement("p", { style: {
                fontSize: '14px',
                color: '#62656D',
                lineHeight: '22px',
            } }, props.content)),
        okText: props.okText,
        cancelText: props.cancelText,
        okButtonProps: {
            style: {
                border: 'none',
                background: '@primary-color',
                borderRadius: ' 4px',
                color: '#ffffff',
                fontSize: '14px',
            },
        },
        cancelButtonProps: props.cancelButtonProps ? props.cancelButtonProps : {
            style: {
                border: ' 1px solid #dee0e3',
                borderRadius: '4px',
                fontSize: '14px',
                color: '#242931',
            },
        },
    });
};
export default Prompt;
//# sourceMappingURL=index.js.map